<template>
  <div class="process-item-base">
    <el-form :model="form" :rules="rules" class="form" ref="form">
      <el-form-item :label="$t('base_process_item_base.liu_cheng_ming_cheng')" prop="workflowName">
        <el-input v-model="form.workflowName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('base_process_item_base.suo_zai_fen_zu')" prop="workflowClass">
        <custom-select v-model="form.workflowClass" code="workflow_class" placeholder="" @change="workflowClassChange"></custom-select>
      </el-form-item>
      <el-form-item :label="$t('base_process_item_base.liu_cheng_lei_xing')" prop="workflowType">
        <work-flow-type-text v-model="form.workflowType" type="select" :workflowClass="form.workflowClass" :workflowId="workflowId" :disabled="!form.workflowClass"></work-flow-type-text>
      </el-form-item>
      <el-form-item :label="$t('base_process_item_base.liu_cheng_miao_shu')" prop="workflowDesc">
        <el-input v-model="form.workflowDesc"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" @click="onSave">{{ $t('Common.com_save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onNext">{{ $t('base_process_item_base.xyblcsz') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import workFlowTypeText from './work_flow_type_text';

export default {
  components: { workFlowTypeText },
  props: {
    workflowId: [String, Number],
  },
  data() {
    return {
      form: {
        // 流程名称
        workflowName: '',
        // 所在分组
        workflowClass: '',
        // 流程类型
        workflowType: '',
        // 说明
        workflowDesc: '',
        // 是否抄送
        isCc: false,
      },
    };
  },
  computed: {
    rules() {
      return {
        workflowName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        workflowClass: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        workflowType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    onCancel() {
      // this.jump('/examine/approvalProcess', {}, true);
      this.$router.replace('/examine/approvalProcess');
    },
    workflowClassChange() {
      this.form.workflowType = '';
    },
    save(isNext) {
      this.$postJSON(
        apis.workflowInfoSave,
        {
          ...this.form,
          workflowId: this.workflowId,
        },
        true
      ).then((res) => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_edit_success'),
        });
        this.$emit('save', res.data);
        if (isNext) {
          this.$emit('next');
        }
      });
    },
    create(isNext) {
      this.$postJSON(apis.workflowInfoSave, this.form, true).then((res) => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_add_success'),
        });
        this.$emit('create', res.data);
        if (isNext) {
          this.$emit('next');
        }
      });
    },
    saving(isNext) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.workflowId) {
            this.save(isNext);
          } else {
            this.create(isNext);
          }
        }
      });
    },
    onNext() {
      this.saving(true);
    },
    onSave() {
      this.saving();
    },
    cancel() {
      this.$emit('cancel');
    },
    initData() {
      if (this.workflowId) {
        this.$getJSON(`${apis.workflowInfo}/${this.workflowId}`).then((res) => {
          this.$setFormatData(this.form, res.data.workflowInfoBo || {});
          // validator value type 异常处理
          this.form.workflowClass = String(this.form.workflowClass);
        });
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.process-item-base {
  .form {
    width: 400px;
  }
}
</style>
